<div class="current-period">
  {{ changeInfo.currentPeriod | displayValue }}
</div>
@if (changeInfo.previousPeriod) {
  <div
    class="previous-period"
    [ngClass]="{
      'positive-change': changeInfo.previousPeriodChangeType === changeType.POSITIVE_CHANGE,
      'negative-change': changeInfo.previousPeriodChangeType === changeType.NEGATIVE_CHANGE,
      'no-change': changeInfo.previousPeriodChangeType === changeType.NO_CHANGE,
    }"
  >
    @if (changeInfo.previousPeriodChangeDirection === changeDirection.UPWARD_CHANGE) {
      <mat-icon>arrow_drop_up</mat-icon>
    }
    @if (changeInfo.previousPeriodChangeDirection === changeDirection.DOWNWARD_CHANGE) {
      <mat-icon>arrow_drop_down</mat-icon>
    }
    <span>{{ changeInfo.previousPeriod | displayValue }}</span>
  </div>
}
